import React from 'react';
import { Link } from 'react-router-dom';

export function WorkflowInputLayout({ title, children }) {
    
  return (
    <div className="min-h-screen bg-gray-50 font-ui">
        <div className="p-8 max-w-7xl mx-auto">
          <Link
            to="/utility/workflow"
            className="inline-flex items-center text-sm text-blue-600 hover:text-blue-800 mb-4 font-ui"
          >
            ← Back to Workflow
          </Link>
          <h1 className="text-2xl font-bold text-gray-800 mb-6 font-ui">{title}</h1>
          {children}
        </div>
    </div>
  );
}
